module.exports = __webpack_public_path__ + "assets/img/image-55-1920.039f2f69.webp";